<ejs-dialog #dialog id="dialog" [isModal]='isModal' [animationSettings]='animationSettings' [closeOnEscape]='true'
  [showCloseIcon]='false' [width]='modalWidth' [position]='position' [visible]='visible' [height]='modalHeight'
  (close)='onDialogClose($event)' (open)='onDialogOpen($event)'>

  <ng-template #header>
    <h3>Custom Export</h3>
  </ng-template>

  <ng-template #content>
    <div class="container-fluid">
      <div class="d-flex flex-column">
        <div class="row" id='top'>
          <div class="inputs-div d-flex flex-column">
            <div class="form-group flex-column col-sm-7">
              <label for='exportName'>Export Name</label>
              <input id='templateName' name='templateName' type='text' class="form-control"
                (keyup)="templateNameKeyUp($event)">
              <div *ngIf="templateNameMissing">
                <span class="text-danger">Template name required</span>
              </div>
            </div>
            <div class="d-flex fled-row">
            <div class="form-group flex-row mt-2 col-sm-7 me-3">
              <ejs-autocomplete id='atcelement' [dataSource]='properties' placeholder='Search' [autofill]='autofill'
                (change)="onAtcSelect($event)" (blur)="onAtcSelect($event)" (click)="clearAttributesActive()">
              </ejs-autocomplete>
            </div>
            <div class="col-sm-1 d-flex pt-3">
              <i class="fal fa-search" aria-hidden="true"></i>
            </div>
          </div>
          </div>
        </div>
        <div class="row">
          <!-- above accordion section -->
          <div class="d-flex">
            <div class="col-sm-8 text-left selectedBoxes">
              <ejs-checkbox (change)="selectAll($event)" label="Select All" [checked]="isSelectAllChecked()">
              </ejs-checkbox>
              <span class="badge badge-blue">
                {{properties?.length}}
              </span>
              <span class="selected-numbers">Selected</span>
              <span class="badge badge-blue"> {{selectedAttrArray?.length}} of {{properties?.length}}</span>
            </div>

            <div class="col-sm-4 justify-content-end text-end accordion-links">
              <a href='javascript:void(0)' (click)="collapseAll()">Collapse All </a> |
              <a href='javascript:void(0)' (click)="expandAll()">Expand All </a>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="d-flex">
            <ejs-accordion #attrAccordion expandMode='Mulitple' (created)='accordionCreated($event)'
              (expanding)="expanding($event)" (clicked)="onClick($event)">
              <e-accordionitems>
                <ng-container *ngIf="attributes.length">
                  <e-accordionitem *ngFor="let attr of attributes; let i = index">
                    <!-- header section -->
                    <ng-template #header>
                      <ejs-checkbox (change)="checkSectionChanged($event, attr.caption)" label="{{attr.caption}}"
                        [checked]="isHeaderChecked(attr.caption)" [disabled]="isHeaderDisabled(attr.caption)">
                      </ejs-checkbox>
                      <span class="badge badge-blue">{{attrFieldCounter(attr)}}</span>
                      <span class="pull-right header-span">
                        <a href="javascript:void(0);" (click)="scrollToElement('#top')">
                          <i class="far fa-arrow-up" aria-hidden="true"></i>Top</a>
                      </span>
                    </ng-template>
                    <!-- content section -->
                    <ng-template #content let-data>
                      <ul class="accordionUl">
                        <!--here we need to loop over the fields but at the correct level, since the sections may be at more than one level of an attribute-->
                        <li id="{{formatId(item.name)}}" class="accordionItem"
                          *ngFor="let item of attr.fields; let a = index">
                          <ejs-checkbox label="{{item.caption}}" (change)="chkChanged($event, item.name)"
                            cssClass="ejsChk" [checked]="isChecked(item.name)" [disabled]="isDisabled(item.name)">
                          </ejs-checkbox>
                        </li>

                        <ng-container *ngFor="let innerSection of getAttrSections(attr); let s = index">
                          <li id="{{formatId(innerField.name)}}" class="accordionItem"
                            *ngFor="let innerField of innerSection.fields; let s = index">
                            <ejs-checkbox label="{{innerField.caption}}"
                              (change)="chkChanged($event, innerField.name)" cssClass="ejsChk"
                              [checked]="isChecked(innerField.name)"></ejs-checkbox>
                          </li>
                        </ng-container>


                      </ul>
                    </ng-template>
                  </e-accordionitem>
                </ng-container>

              </e-accordionitems>
            </ejs-accordion>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #footerTemplate>
    <div class="d-flex">
      <div class="buttons-div center-block text-center">
        <button type="button" id="modalCancel" class="btn btn-default dialogButton" (click)="modalCancel()"
          data-ripple="true">Cancel</button>

        <button type="button" id="modalSave" class="btn btn-primary dialogButton" (click)="saveTemplate()"
          data-ripple="true">Save</button>
      </div>
    </div>
  </ng-template>
</ejs-dialog>
